export interface RouteValue {
  path: string
  nestedPath?: string
  isProtected?: boolean
  backPath?: string
  isShowAIChat?: boolean
}

const routes = {
  HOME: {
    path: '/',
    isProtected: false,
  },
  SIGN_IN: {
    path: '/sign-in',
    isProtected: false,
  },
  SIGN_IN_CHALLENGE: {
    path: '/sign-in/challenge',
    isProtected: false,
  },
  SIGN_IN_CHALLENGE_FAILURE: {
    path: '/sign-in/challenge/failure',
    isProtected: false,
  },
  APPLICATION_UNDER_REVIEW: {
    path: '/application-under-review',
    isProtected: false,
  },

  // Recovery
  RECOVERY: {
    path: '/recovery',
    isProtected: false,
    backPath: '/sign-in',
  },
  RECOVERY_METHOD: {
    path: '/recovery/method',
    nestedPath: 'method',
    isProtected: false,
    backPath: '/recovery',
  },
  RECOVERY_SEND_PHONE: {
    path: '/recovery/send-phone',
    nestedPath: 'send-phone',
    isProtected: false,
    backPath: '/recovery/method',
  },
  RECOVERY_SEND_EMAIL: {
    path: '/recovery/send-email',
    nestedPath: 'send-email',
    isProtected: false,
    backPath: '/recovery/method',
  },
  RECOVERY_MAGIC_LINK: {
    path: '/recovery/magic-link',
    nestedPath: 'magic-link',
    isProtected: false,
    backPath: '/recovery/send-email',
  },
  RECOVERY_SUBMIT: {
    path: '/recovery/submit',
    nestedPath: 'submit',
    isProtected: false,
    backPath: '/recovery/send-phone',
  },
  RECOVERY_VERIFICATION: {
    path: '/recovery/verification',
    nestedPath: 'verification',
    isProtected: false,
  },
  RECOVERY_PASSKEY: {
    path: '/recovery/passkey',
    nestedPath: 'passkey',
    isProtected: false,
  },
  RECOVERY_PROBLEM: {
    path: '/recovery/problem',
    nestedPath: 'problem',
    isProtected: false,
  },
  RECOVERY_REVIEW: {
    path: '/recovery/review',
    nestedPath: 'review',
    isProtected: false,
  },
  // Overview
  OVERVIEW: {
    path: '/overview',
    isProtected: true,
    isShowAIChat: true,
  },
  // Checking account routes
  CHECKING_ACCOUNT: {
    path: '/checking/:alias',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  CHECKING_ACCOUNT_DETAILS: {
    path: '/checking/:alias/details',
    isProtected: true,
    backPath: '/checking/:alias',
    isShowAIChat: true,
  },
  CHECKING_ACCOUNT_ACTIVITY: {
    path: '/checking/:alias/activity',
    isProtected: true,
    backPath: '/checking/:alias',
    isShowAIChat: true,
  },
  CHECKING_ACCOUNT_ACTIVITY_DETAILS: {
    path: '/checking/:alias/activity/:transactionId',
    isProtected: true,
    backPath: '/checking/:alias/activity',
    isShowAIChat: true,
  },
  CHECKING_ACCOUNT_DEBIT_CARD: {
    path: '/checking/:alias/debit-card',
    isProtected: true,
    backPath: '/checking/:alias',
    isShowAIChat: true,
  },
  ACTIVATE: {
    path: '/activate',
    isProtected: true,
    isShowAIChat: true,
  },
  CHECKING_ACCOUNT_DEBIT_CARD_ACTIVATE: {
    path: '/checking/:alias/debit-card/activate',
    isProtected: true,
    backPath: '/checking/:alias/debit-card',
    isShowAIChat: true,
  },
  CHECKING_ACCOUNT_DEBIT_CARD_SET_PIN: {
    path: '/checking/:alias/debit-card/activate/set-pin',
    isProtected: true,
    backPath: '/checking/:alias/debit-card',
    isShowAIChat: true,
  },
  CHECKING_ACCOUNT_DEBIT_CARD_ACTIVATE_SUCCESS: {
    path: '/checking/:alias/debit-card/activate/success/',
    isProtected: true,
    backPath: '/checking/:alias/debit-card',
    isShowAIChat: true,
  },
  // Savings account routes
  SAVINGS_ACCOUNT: {
    path: '/savings/:alias',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  SAVINGS_ACCOUNT_DETAILS: {
    path: '/savings/:alias/details',
    isProtected: true,
    backPath: '/savings/:alias',
    isShowAIChat: true,
  },
  SAVINGS_ACCOUNT_ACTIVITY: {
    path: '/savings/:alias/activity',
    isProtected: true,
    backPath: '/savings/:alias',
    isShowAIChat: true,
  },
  SAVINGS_ACCOUNT_ACTIVITY_DETAILS: {
    path: '/savings/:alias/activity/:transactionId',
    isProtected: true,
    backPath: '/savings/:alias/activity',
    isShowAIChat: true,
  },
  INVESTMENTS: {
    path: '/investments',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  INVESTMENTS_OVERVIEW: {
    path: '/investments/overview',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  INVESTMENTS_HOLDINGS_OVERVIEW: {
    path: '/investments/overview/holdings/:assetAllocation/category/:category',
    isProtected: true,
    backPath: '/investments/overview',
  },
  INVESTMENTS_HOLDINGS_DETAILS_OVERVIEW: {
    path: '/investments/overview/holdings/:assetAllocation/category/:category/:symbol',
    isProtected: true,
    backPath: '/investments/overview/holdings/:assetAllocation/category/:category',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT: {
    path: '/investments/:alias',
    isProtected: true,
    backPath: '/investments',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT_DETAIL: {
    path: '/investments/:alias/details',
    isProtected: true,
    backPath: '/investments/:alias',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT_HOLDINGS: {
    path: '/investments/:alias/holdings/:assetAllocation/category/:category',
    isProtected: true,
    backPath: '/investments/:alias',
    isShowAIChat: true,
  },
  // HOLDINGS ALLOCATION FOR APEX USERS (NO SECTORS JUST UNDER ASSET ALLOCATION)
  INVESTMENTS_ALLOCATION_HOLDINGS_LIST: {
    path: '/investments/:alias/holdings/:assetAllocation',
    isProtected: true,
    backPath: '/investments/:alias',
    isShowAIChat: true,
  },
  // HOLDINGS DETAILS FOR ASSET ALLOCATION HOLDINGS
  INVESTMENTS_ALLOCATION_HOLDINGS_DETAILS: {
    path: '/investments/:alias/holdings/:assetAllocation/:symbol',
    isProtected: true,
    backPath: '/investments/:alias/holdings/:assetAllocation',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT_HOLDINGS_DETAILS: {
    path: '/investments/:alias/holdings/:assetAllocation/category/:category/:symbol',
    isProtected: true,
    backPath: '/investments/:alias/holdings/:assetAllocation/category/:category',
    isShowAIChat: true,
  },
  INVESTMENTS_COMPANION_ACCOUNT_HOLDINGS: {
    path: '/investments/:alias/companion/holdings',
    isProtected: true,
    backPath: '/investments/:alias',
    isShowAIChat: true,
  },
  INVESTMENTS_COMPANION_ACCOUNT_HOLDINGS_DETAILS: {
    path: '/investments/:alias/companion/holdings/:symbol',
    isProtected: true,
    backPath: '/investments/:alias/companion/holdings',
    isShowAIChat: true,
  },
  // Evergreen Accounts route
  EVERGREEN_ACCOUNTS: {
    path: '/evergreen-accounts',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT_ACTIVITY: {
    path: '/investments/:alias/activity',
    isProtected: true,
    backPath: '/investments/:alias',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT_ACTIVITY_DETAILS: {
    path: '/investments/:alias/activity/:transactionId',
    isProtected: true,
    backPath: '/investments/:alias/activity',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT_TRADES: {
    path: '/investments/:alias/activity/:transactionId/trades',
    isProtected: true,
    backPath: '/investments/:alias/activity/:transactionId',
    isShowAIChat: true,
  },
  INVESTMENTS_ACCOUNT_TRADES_DETAILS: {
    path: '/investments/:alias/activity/:transactionId/trades/:tradeId',
    isProtected: true,
    backPath: '/investments/:alias/activity/:transactionId/trades',
    isShowAIChat: true,
  },
  // Foundation route
  FOUNDATION_ACCOUNT: {
    path: '/foundation',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  // Cash Accounts route
  CASH_ACCOUNTS_OVERVIEW: {
    path: '/cash/overview',
    isProtected: true,
    backPath: '/evergreen-accounts',
    isShowAIChat: true,
  },
  // Linked Accounts
  LINKED_ACCOUNTS: {
    path: '/linked-accounts',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  // Evergreen Intelligence
  EVERGREEN_INTELLIGENCE: {
    path: '/evergreen-intelligence',
    isProtected: true,
    backPath: '/overview',
  },
  // Transfer,
  TRANSFER: {
    path: '/transfer',
    isProtected: true,
    backPath: '/overview',
  },
  TRANSFER_BANK: {
    path: '/transfer/bank-transfer',
    isProtected: true,
    backPath: '/transfer',
  },
  TRANSFER_WIRE: {
    path: '/transfer/wire',
    isProtected: true,
    backPath: '/transfer',
  },
  TRANSFER_WIRE_REVIEW: {
    path: '/transfer/wire/review',
    isProtected: true,
    backPath: '/transfer/wire',
  },
  TRANSFER_WIRE_SUCCESS: {
    path: '/transfer/wire/success',
    isProtected: true,
    backPath: '/transfer/',
  },
  TRANSFER_ROLLOVER_IRA: {
    path: '/transfer/rollover-ira',
    isProtected: true,
    backPath: '/transfer',
  },
  TRANSFER_ACCOUNT: {
    path: '/transfer/account-transfer',
    isProtected: true,
    backPath: '/transfer',
  },
  TRANSFER_ACCOUNT_REVIEW: {
    path: '/transfer/account-transfer/review/:transferAlias',
    isProtected: true,
    backPath: '/transfer',
  },
  // Settings
  SETTINGS: {
    path: '/settings',
    isProtected: true,
    backPath: '/overview',
  },
  SETTINGS_PERSONAL_INFO: {
    path: '/settings/personal-info',
    isProtected: true,
    backPath: '/settings',
  },
  SETTINGS_PASSKEY: {
    path: '/settings/passkey',
    isProtected: true,
    backPath: '/settings',
  },
  SETTINGS_PASSKEY_DETAILS: {
    path: '/settings/passkey/details',
    isProtected: true,
    backPath: '/settings/passkey',
  },
  SETTINGS_BENEFICIARIES: {
    path: '/settings/beneficiaries',
    isProtected: true,
    backPath: '/settings',
  },
  SETTINGS_BANK_TRANSFER_ACCOUNTS: {
    path: '/settings/bank-transfer-accounts',
    isProtected: true,
    backPath: '/settings',
  },
  SETTINGS_BANK_TRANSFER_ACCOUNTS_DETAILS: {
    path: '/settings/bank-transfer-accounts/details',
    isProtected: true,
    backPath: '/settings/bank-transfer-accounts',
  },
  // Documents
  DOCUMENTS: {
    path: '/documents',
    isProtected: true,
    backPath: '/overview',
    isShowAIChat: true,
  },
  DOCUMENTS_STATEMENTS: {
    path: '/documents/statements',
    isProtected: true,
    backPath: '/documents',
    isShowAIChat: true,
  },
  DOCUMENTS_TRADE_CONFIRMATION: {
    path: '/documents/account/:alias/trade-confirmations',
    isProtected: true,
    backPath: '/documents',
    isShowAIChat: true,
  },
  DOCUMENTS_LEGAL_PARTNER: {
    path: '/documents/legal/partner/',
    isProtected: true,
    backPath: '/documents',
    isShowAIChat: true,
  },
  DOCUMENTS_STATEMENTS_BY_YEAR_AND_MONTH: {
    path: '/documents/statements/year/month/',
    backPath: '/documents',
    isShowAIChat: true,
  },
  DOCUMENTS_TAXES_YEAR: {
    path: '/documents/taxes/year/',
    isProtected: true,
    backPath: '/documents',
    isShowAIChat: true,
  },
  // Help Center
  HELP_CENTER: {
    path: '/contact-us/',
    isProtected: true,
    backPath: '/overview',
  },
  // Enrollment
  ENROLLMENT: {
    path: '/enrollment',
    isProtected: false,
  },

  // 404
  NOT_FOUND_404: {
    path: '/not-found-404',
    isProtected: false,
  },
}

// Record<string, RouteValue> doesn't suggest Route, so we need to define the following types to have keys suggested by TypeScript
type Routes = typeof routes
type RouteKey = keyof Routes
type Route = Record<RouteKey, RouteValue>
export const WEALTH_ROUTES = routes as Route
